import RequestService from './request';

export interface ShutDownAllServersFilters {
    locationId?: number | null;
    nodeId?: number | null;
    nestId?: number | null;
    eggId?: number | null;
}

export interface ShutDownAllServersPreviewServer {
    id: number;
    uuid: string;
    uuidShort: string;
    name: string;
    node: {
        id: number;
        name: string;
    };
    egg: {
        id: number;
        name: string;
        tag: string | null;
    } | null;
    owner: {
        id: number;
        email: string;
        nameFirst: string | null;
        nameLast: string | null;
        name: string;
    } | null;
}

export interface ShutDownAllServersPreviewNode {
    id: number;
    name: string;
    maintenanceMode: boolean;
    location: {
        id: number;
        short: string;
    } | null;
}

export interface ShutDownAllServersPreviewResponse {
    servers: ShutDownAllServersPreviewServer[];
    nodes: ShutDownAllServersPreviewNode[];
}

export interface ExecuteShutDownAllServersRequest extends ShutDownAllServersFilters {
    toggleMaintenance: boolean;
    _reauth_token: string;
}

interface RawPreviewResponse {
    servers: Array<{
        id: number;
        uuid: string;
        uuid_short: string;
        name: string;
        node: { id: number; name: string };
        egg: { id: number; name: string; tag: string | null } | null;
        owner: {
            id: number;
            email: string;
            name_first: string | null;
            name_last: string | null;
            name: string;
        } | null;
    }>;
    nodes: Array<{
        id: number;
        name: string;
        maintenance_mode: boolean;
        location: { id: number; short: string } | null;
    }>;
}

interface RawExecuteResponse {
    node_ids: number[];
}

const filtersToQuery = (filters: ShutDownAllServersFilters): Record<string, number> => {
    const out: Record<string, number> = {};
    if (filters.locationId != null) out.location_id = filters.locationId;
    if (filters.nodeId != null) out.node_id = filters.nodeId;
    if (filters.nestId != null) out.nest_id = filters.nestId;
    if (filters.eggId != null) out.egg_id = filters.eggId;
    return out;
};

class ServerShutdownService {
    preview(filters: ShutDownAllServersFilters): Promise<ShutDownAllServersPreviewResponse> {
        return RequestService.get('/servers/shutdown-all/preview', filtersToQuery(filters)).then((res: RawPreviewResponse) => ({
            servers: res.servers.map((s) => ({
                id: s.id,
                uuid: s.uuid,
                uuidShort: s.uuid_short,
                name: s.name,
                node: s.node,
                egg: s.egg,
                owner: s.owner
                    ? {
                          id: s.owner.id,
                          email: s.owner.email,
                          nameFirst: s.owner.name_first,
                          nameLast: s.owner.name_last,
                          name: s.owner.name,
                      }
                    : null,
            })),
            nodes: res.nodes.map((n) => ({
                id: n.id,
                name: n.name,
                maintenanceMode: n.maintenance_mode,
                location: n.location,
            })),
        }));
    }

    execute(data: ExecuteShutDownAllServersRequest): Promise<{ nodeIds: number[] }> {
        const body: Record<string, unknown> = {
            toggle_maintenance: data.toggleMaintenance,
            _reauth_token: data._reauth_token,
            ...filtersToQuery(data),
        };

        return RequestService.post('/servers/shutdown-all', body).then((res: RawExecuteResponse) => ({
            nodeIds: res.node_ids,
        }));
    }
}

export default new ServerShutdownService();
